export function mapVariableItems(variables) {
  return (variables ?? []).map((item) => ({
    key: `${String(item?.id ?? '')}-${String(item?.name ?? '')}`,
    id: item?.id ?? null,
    label: String(item?.name ?? ''),
    description: String(item?.description ?? ''),
    mapping: `{{${String(item?.name ?? '')}}}`,
  }));
}
